<template>
  <div :class="['menu-form', { mobile: $mq === 'xs' }]">
    <WithCart
      v-slot="{ sections, availabilities, loading }"
      :is-merchant="canMerchant"
    >
      <v-row v-if="loading" class="pa-6 text-center" dense>
        <v-col cols="12">
          <h4>Loading...</h4>
        </v-col>
        <v-col cols="12">
          <v-progress-circular indeterminate></v-progress-circular>
        </v-col>
      </v-row>
      <div v-else>
        <NewOrderHeader
          :gallery-imgs="galleryImgs"
          :availability="getAvailabilities"
        />

        <div :class="{ 'pa-2': $mq !== 'xs' }">
          <transition name="fade" mode="out-in">
            <v-container>
              <v-row v-if="!getRealItems.length">
                <v-col>
                  <h2>No Items Found</h2>
                  <h3
                    >We apologize, but there is nothing available for purchase
                    at this time.</h3
                  >
                </v-col>
              </v-row>

              <v-row v-else>
                <v-col cols="12" sm="7" md="6" class="px-0">
                  <v-card
                    :outlined="!isXSorSM"
                    :flat="isXSorSM"
                    :class="[isXSorSM ? 'pa-1' : 'pa-4', { 'mr-3': !isXSorSM }]"
                  >
                    <MenuForm :sections="getMenu" />
                  </v-card>
                </v-col>
                <v-col
                  cols="12"
                  sm="5"
                  md="6"
                  class="px-0 px-sm-2 checkout-pane-container"
                >
                  <CheckoutPane />
                </v-col>
              </v-row>
              <DatePickerFab />
            </v-container>
          </transition>
        </div>
      </div>
    </WithCart>

    <!-- <v-snackbar value="true" vertical color="blue-grey lighten-2"
      ><h1>Added! </h1>
      <h3 class="pb-3">
        The item has been added.
      </h3>
    </v-snackbar> -->
    <transition name="fade" mode="out-in">
      <v-btn
        v-if="showScrollToCart && getAvailabilities.length"
        v-scroll-to="'#cart'"
        color="blue darken-2"
        fixed
        bottom
        right
        class="view-cart-btn white--text"
        ><v-icon small left>mdi-chevron-triple-down</v-icon>View Cart</v-btn
      >
    </transition>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { GuestRoutes } from '@/constants/RouteNames'
import WithCart from '@/components/DataProviders/WithCart'
import MenuForm from '@/components/MenuForm'
import NewOrderHeader from '@/components/NewOrderHeader'
import CheckoutPane from '@/components/CheckoutPane'
import DatePickerFab from '@/components/DatePickerFab'
import _includes from 'lodash/includes'
import liveAgent from '@/utils/liveAgent'
import fullstory from '@/plugins/fullstory'

export default {
  name: 'NewOrderView',
  components: {
    MenuForm,
    NewOrderHeader,
    CheckoutPane,
    DatePickerFab,
    WithCart,
  },
  data: () => {
    return {
      items: [],
      fetchShopInterval: null,
    }
  },
  mounted() {
    if (this.getIsLiveChatEnabled) {
      window.liveAgent_btn
        ? liveAgent.show()
        : liveAgent.load(this.getLiveChatButtonId)
    }
  },
  beforeDestroy() {
    liveAgent.hide()
    clearInterval(this.fetchShopInterval)
  },
  async created() {
    if (!(await this.validateSession())) {
      await this.logout()
    }
    try {
      await this.fetchShop(true)
      this.fetchShopInterval = setInterval(() => this.fetchShop(true), 60000)
    } catch (error) {
      // console.error(JSON.stringify(error))
    } finally {
      this.loading = false
    }
  },
  computed: {
    ...mapGetters('cart', ['showScrollToCart']),
    ...mapGetters('itemAndSection', ['getRealItems']),
    ...mapGetters('auth', ['getAuthUser', 'canMerchant']),
    ...mapGetters('shop', [
      'getMenu',
      'getShopDetail',
      'getIsLiveChatEnabled',
      'getLiveChatButtonId',
      'getIsMaintenanceModeOn',
      'getIsShopDead',
      'getFullStoryId',
    ]),
    ...mapGetters('availabilities', ['getAvailabilities']),
    isXSorSM() {
      return _includes(['sm', 'xs'], this.$mq)
    },
    galleryImgs() {
      let imgs = this.getShopDetail('Menu Gallery')
      return imgs ? JSON.parse(imgs) : []
    }, // galleryImgs
  },
  methods: {
    ...mapActions('auth', ['validateSession', 'logout', 'setupFullStory']),
    ...mapActions('shop', ['fetchShop']),
    _includes,
  },
  watch: {
    getIsMaintenanceModeOn: {
      handler(val) {
        if (val) {
          this.$router.push({ name: GuestRoutes.MAINTENANCE })
        }
      },
      immediate: true,
    },
    getIsShopDead: {
      handler(val) {
        if (val) {
          this.$router.push({ name: GuestRoutes.EXPIRED })
        }
      },
      immediate: true,
    },
    getAuthUser: {
      async handler(authUser) {
        let fullStoryId = this.getFullStoryId
        if (authUser && !!fullStoryId) {
          await fullstory.init(fullStoryId)
          this.setupFullStory()
        }
      },
      immediate: true,
    },
  }, // watch
}
</script>

<style lang="scss">
.checkout-pane-container {
  // position: relative;
}

.cart--wrap {
  flex-basis: auto;
  min-height: 0;
  overflow: auto;
}

.mobile {
  .cart--wrap {
    flex-basis: auto;
    min-height: 0;
    overflow: auto;
  }
  .acknowledge-payment-checkbox {
    .v-label {
      font-size: 1.3rem;
      line-height: 1.2;
    }
  }
}

.view-cart-btn {
  z-index: 5;
}
.acknowledge-payment-checkbox {
  .v-label {
    line-height: 1.4;
    font-size: 0.9rem;
  }
  &.unchecked .v-label {
    color: #e64a19;
  }
}

.roundedDotChatButton .roundedDotChatButtonText {
  font-family: proxima-nova, sans-serif;
  font-weight: 700 !important;
  font-style: normal;
  text-transform: uppercase;
  font-size: 0.875rem !important;
  letter-spacing: 0.0892857143em !important;
}
</style>
